import isEmpty from 'lodash/isEmpty';
import SharedUtils from './SharedUtils';
const mapAddressValue = (addressLines, addressOptions) => {
    const isConcat = addressOptions?.includes('+');
    const options = isConcat ? addressOptions?.split('+') : addressOptions?.split('|');
    const addressValue = options
        ?.map((option) => addressLines?.[option] ?? '')
        .filter((value) => value);
    if (!isEmpty(addressValue)) {
        return isConcat ? addressValue?.join(', ') : addressValue?.[0];
    }
    return '';
};
export const parseAddress = (addressComponents, deliveryAddressMapping, filterby = 'long_name') => {
    const flatResponse = SharedUtils.flatGoogleAddress(addressComponents, filterby);
    const { pinCode: postalCodeKey, country: countryKey, state: stateKey, city: cityKey, addressLine0: addressLine0Key, addressLine1Prepend: addressLine1PrependKey, addressLine1: addressLine1Key, addressLine2: addressLine2Key, addressLine1Alt: addressLine1AltKey, } = deliveryAddressMapping ?? {};
    let pinCode = '';
    let country = '';
    let city = '';
    let state = '';
    let addressLines = [];
    if (flatResponse) {
        pinCode = flatResponse?.[postalCodeKey] ?? '';
        country = flatResponse?.[countryKey] ?? '';
        city = mapAddressValue(flatResponse, cityKey);
        state = flatResponse?.[stateKey] ?? '';
        const locality = mapAddressValue(flatResponse, addressLine2Key);
        const addressLine1PrependValue = mapAddressValue(flatResponse, addressLine1PrependKey) ?? '';
        const addressLine1Value = (mapAddressValue(flatResponse, addressLine1Key) || mapAddressValue(flatResponse, addressLine1AltKey)) ?? '';
        const addressLine1 = addressLine1PrependValue
            ? `${addressLine1PrependValue} ${addressLine1Value}`
            : addressLine1Value;
        const floor = mapAddressValue(flatResponse, addressLine0Key);
        addressLines = [floor, addressLine1];
        if (locality && locality !== city) {
            addressLines.push(locality);
        }
    }
    return {
        city,
        pinCode,
        state,
        country,
        addressLines,
    };
};
